import clsx from 'clsx';
import React from 'react';
import {} from './TableCellEmptyText.types';
const TableCellEmptyText = ({ children, className }) => (React.createElement("div", { className: clsx('text-xs text-grey-60', className), "data-fullstory": true }, children));
export default TableCellEmptyText;
